<router-outlet></router-outlet>
<app-singleton-confirmation-modal><app-singleton-confirmation-modal>